import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-scroll';
import { useParams } from 'react-router-dom';

import Hamburger from './Hamburger';

import './header.css';

import { Context } from '../../StoreContext/Context';

const Header = () => {
  const { info, inforRegister, config , access} = useContext(Context);

  const [isMobile, SetIsMobile] = useState(
    window.matchMedia('(max-width: 992px)').matches
  );

  useEffect(() => {
    window.addEventListener('resize', () => {
      SetIsMobile(window.matchMedia('(max-width: 992px)').matches);
    });
  });

  const { eventKey } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      className="transparent header"
      style={{
        background: `linear-gradient(90deg, ${info?.headerBgColor1} 0%, ${info?.headerBgColor2} 90%)`,
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12 menulist">
            {/* logo begin */}
            <div id="logo" className="header__brand">
              <Link
                  style={{ color: `${info?.fontColor}` }}
                  to="dalk-image"
                  smooth
                  duration={1000}
                >
                <img className="logo" src={info?.logo} alt="" />
              </Link>
            </div>
            {/* logo close */}
            {/* small button begin */}
            <div
              className="header__nav-toggle"
              onClick={() => {
                setMenuOpen((o) => !o);
              }}
            >
              {' '}
              <Hamburger />
            </div>
            {/* small button close */}
            {/* mainmenu begin */}
            <nav
              id="nav"
              className={`header__nav ${menuOpen ? '' : 'hidden'}`}
              style={{
                background: isMobile
                  ? `linear-gradient(90deg, ${info?.headerBgColor1} 0%, ${info?.headerBgColor2} 90%)`
                  : '',
              }}
            >
              <ul id="mainmenu" className="ms-2">
                <li>
                  <Link
                    style={{ color: `${info?.fontColor}` }}
                    to="dalk-image"
                    smooth
                    duration={1000}
                  >
                    Início
                  </Link>
                </li>

                {/* <li>
                  <Link
                    style={{ color: `${info?.fontColor}` }}
                    to="section-about"
                    smooth
                    duration={1000}
                  >
                    Sobre
                  </Link>
                </li> */}

                { config?.palestrantes &&
                <li>
                  <Link
                    style={{ color: `${info?.fontColor}` }}
                    to="section-speakers"
                    smooth
                    duration={1000}
                  >
                    Palestrantes
                  </Link>
                </li>
                }

                { config?.agenda &&
                <li >
                    <Link
                      style={{ color: `${info?.fontColor}` }}
                      to="section-schedule"
                      smooth
                      duration={1000}
                    >
                      Agenda
                    </Link>
                  </li>
                }

                { access?.show_signup_button &&
                <li>
                  <Link
                    style={{ color: `${info?.fontColor}` }}
                    to="section-register"
                    smooth
                    duration={1000}
                  >
                    Inscrição
                  </Link>
                </li>
                }

                <li>
                  <a
                    style={{ color: `${info?.fontColor}` }}
                    href={`/${eventKey}/signin`}
                    target="_blank"
                  >
                    Login
                  </a>
                </li>

                {/* <li>
                  <div className="toggle-container">
                    <span style={{ color: theme ? 'grey' : 'yellow' }}>☀︎</span>
                    <span className="toggle">
                      <input
                        checked={theme}
                        onChange={() => themeToggler()}
                        id="checkbox"
                        className="checkbox"
                        type="checkbox"
                      />
                      <label htmlFor="checkbox" />
                    </span>
                    <span style={{ color: theme ? 'slateblue' : 'grey' }}>
                      ☾
                    </span>
                  </div>
                </li> */}
              </ul>
            </nav>
            {/* mainmenu close */}
          </div>
        </div>
      </div>
    </header >
  );
};

export default Header;
